// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__2vJfc","tooltiptext":"tooltip_tooltiptext__3HLqv"};